import baseDeepDiveContent from "./DeepDiveContent.en";
import { translateResults } from "../i18n/translate";

const lang = "ja";
const t = (text) => translateResults(lang, text);

const TITLE_OVERRIDES = {
  "Digital Wellbeing Environment at Home": "家庭におけるデジタルウェルビーイング環境",
  "Family Communication on Digital Wellbeing and AI":
    "デジタルウェルビーイングとAIに関する家族内コミュニケーション",
  "Parental Resourcefulness and Self-Efficacy": "親の機転と自己効力感",
  "School-Parent Communication": "学校と保護者のコミュニケーション",
};

const deepDiveContent = Object.fromEntries(
  Object.entries(baseDeepDiveContent).map(([key, section]) => [
    key,
    {
      ...section,
      title: TITLE_OVERRIDES[key] || section.title,
      importance: Array.isArray(section.importance)
        ? section.importance.map((p) => t(p))
        : [],
    },
  ])
);

export default deepDiveContent;

